import React from "react";
import Search from "../../components/RoleBased/Search";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { fetchNewUsers, fetchAllUsers, getIsUserLoading, getAllUsers, deleteUserById } from "../../reducers/user";

const SearchContainer = props => <Search {...props} />;

const mapState = (state, props) => ({
    isLoading: getIsUserLoading(state),
    allUsers: getAllUsers(state)
});

const actions = (dispatch, props) => ({
    fetchNewUsers: bindActionCreators(fetchNewUsers, dispatch),
    fetchAllUsers: bindActionCreators(fetchAllUsers, dispatch),
    deleteUser: bindActionCreators(deleteUserById, dispatch)
});

export default connect(mapState, actions)(SearchContainer);